/**
 * TradingMovedBanner — one-line notice that order execution moved to the
 * desktop Quantum Terminal. Shown only when SITE_TRADING_ENABLED is false
 * (the default after the merge). Dismissible per browser.
 *
 * The web app keeps everything analytical: charts, screener, radar, intel,
 * the position-size calculator, situations, the trade journal. It just no
 * longer places orders — that path is blocked at the data layer
 * (utils/binance.js, utils/exchangeTrading.js) and this explains why.
 */
import { useState } from 'react';
import { SITE_TRADING_ENABLED } from '../config';
import { tr } from '@quantum/ui';

const KEY = 'quantum.tradingMovedBannerDismissed';

export default function TradingMovedBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
  });

  if (SITE_TRADING_ENABLED || dismissed) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '6px 14px',
        background: 'var(--acc-deep, #0E2A45)',
        borderBottom: '1px solid var(--w-acc-border, rgba(74,168,255,.45))',
        color: 'var(--hi, #E6EAF2)',
        font: "500 12px/1.4 var(--font-ui, 'Inter', system-ui, sans-serif)",
      }}
    >
      <span style={{ color: 'var(--acc, #4AA8FF)' }}>⬗</span>
      <span style={{ flex: 1 }}>
        {tr('Order execution has moved to the')} <strong>Quantum Terminal</strong> {tr('desktop app. This web app is for analysis, charting and position sizing.')}
      </span>
      <button
        type="button"
        onClick={() => {
          try { localStorage.setItem(KEY, '1'); } catch { /* private mode */ }
          setDismissed(true);
        }}
        style={{
          background: 'transparent', border: '1px solid var(--line2, #2A3346)',
          borderRadius: 4, color: 'var(--mid, #8C96AC)', cursor: 'pointer',
          font: 'inherit', padding: '2px 8px',
        }}
      >
        Dismiss
      </button>
    </div>
  );
}
